import React from 'react';
import { FreeConsultLink } from './FreeConsultLink';
export const Header = ({
  openModal
}) => {
  return <header className="mb-8" data-id="element-238">
      <div className="flex items-center justify-center mb-4" data-id="element-239"></div>
      <a href="https://training.stresslessdogs.nl/va-video" className="text-center block mb-6 bg-blue-50 p-3 rounded-lg border-2 border-blue-300 cursor-pointer hover:bg-blue-100 transition-colors" data-id="element-240">
        <p className="font-bold text-blue-700" data-id="element-241">
          GRATIS INTAKE GESPREK - COACHING VOOR VERLATINGSANGST BIJ HONDEN
        </p>
      </a>
      <h1 className="text-2xl md:text-3xl font-bold text-center mb-6 text-blue-800 leading-tight" data-id="element-242">
        Hoe honden met verlatingsangst de vrijheid beperken van hun baasjes en
        waarom 'gewoon oefenen' het erger maakt
      </h1>
      <div className="text-center mb-4 text-blue-600 font-semibold" data-id="element-243">
        Ontdek waarom verlatingsangst vaak helemaal geen verlatingsangst is
      </div>
      <div className="text-center text-sm text-gray-600 mb-6" data-id="element-244">
        Door Amee van Stressless Dogs | Gespecialiseerd hondengedragstherapeut
      </div>
      <div className="w-full mb-6" data-id="element-245">
        <a href="https://training.stresslessdogs.nl/va-video" data-id="element-246">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9XDnzN9YZefnc2s5KdcnTE/freepik__the-style-is-candid-image-photography-with-natural__77407.png" alt="Bezorgde vrouw kijkt op haar telefoon terwijl haar hond naast haar op de bank ligt" className="w-full h-auto rounded-lg shadow-md cursor-pointer" data-id="element-247" />
        </a>
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-248">
          Elke dag gevangen in je eigen huis, omdat je hond niet alleen kan
          blijven?
        </p>
      </div>
      <div className="w-full h-[1px] bg-gray-200 my-6" data-id="element-249"></div>
    </header>;
};